import { render, staticRenderFns } from "./Pagetion.vue?vue&type=template&id=36a7f488&scoped=true"
import script from "./Pagetion.vue?vue&type=script&lang=js"
export * from "./Pagetion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a7f488",
  null
  
)

export default component.exports